import type {
    BusinessCategoryDetails,
    MenuItemDetails,
} from '@barboxx/models/types';

import { api } from '../../api';
import { throwIfBadResponse } from '../../utils';

const rootPath = 'menu';

export function getMenuCategories(
    businessId: number,
    query?: BusinessCategoryDetails.SearchQuery
) {
    return api.get<Array<BusinessCategoryDetails>>(
        `categories/customer/${businessId}`,
        query
    );
}

export function getMenuItems(
    businessId: number,
    query?: MenuItemDetails.SearchQuery
) {
    return throwIfBadResponse(
        api.get<MenuItemDetails.SearchResponse>(
            `${rootPath}/items/customer/${businessId}`,
            query
        )
    );
}

export function getMenuItem(id: number) {
    return api.get<MenuItemDetails.DetailsResponse>(
        `${rootPath}/items/customer/item/${id}`,
        undefined
    );
}

// export function postMenuItem(data: MenuItem.CreateRequest) {
//     return api.post<MenuItem>(rootPath, data, );
// }

// export function putMenuItem(id: number, data: MenuItem.UpdateRequest) {
//     return api.put<MenuItem>(`${rootPath}/${id}`, data, );
// }

// export function deleteMenuItem({ id }: MenuItem.DeleteRequest) {
//     return api.delete(`${rootPath}/${id}`, undefined, );
// }
